import one from '../assets/svg/projects/one.svg'
import two from '../assets/svg/projects/two.svg'
import three from '../assets/svg/projects/three.svg'
import four from '../assets/svg/projects/four.svg'
import five from '../assets/svg/projects/five.svg'
import six from '../assets/svg/projects/six.svg'
import seven from '../assets/svg/projects/seven.svg'
import eight from '../assets/svg/projects/eight.svg'


export const projectsData = [
    {
        id: 1,
        "projectName": "Website Builder - Drag and Drop Page Builder",
        "projectDesc": "A modern, intuitive drag-and-drop website builder that allows you to create responsive websites without writing code. Design your website visually by dragging elements onto the canvas, customizing their properties, and exporting the generated HTML and CSS.",
        "tags": ["Next.js", "React", "Tailwind CSS","Node.js","Vercel"],
        "code": "https://github.com/Satheeshraj05/Website-Builder",
        "demo": "https://website-builder-three-smoky.vercel.app/",
        "image": one
    },
    {
        id: 2,
        "projectName": "Ai-Saas",
        "projectDesc": "This project involves the development of a comprehensive SaaS platform with AI capabilities for creating and managing text, code, images, videos, and music.",
        "tags": ["Next.js", "React", "Tailwind CSS", "Prisma", "Vercel"],
        "code": "https://github.com/Satheeshraj05/ai-saas-genius",
        "demo": "https://ai-saas-genius-ehwm.vercel.app/",
        "image": two
    },
    {
        id: 3,
        projectName: 'Justframez',
        projectDesc: 'Developed a custom WordPress-based e-commerce platform with optimized galleries, secure payments, and seamless user experience for personalized photo frames.',
        tags: ['Wordpress', 'Figma', 'Hostinger'],
        code: 'https://justframez.in/',
        demo: 'https://justframez.in/',
        image: three
    },
    {
        id: 4,
        projectName: 'Food-Product-Explorer',
        projectDesc: 'Explore food products with Food Product Explorer, a Next.js web app using the OpenFoodFacts API for easy search, filtering, and detailed viewing.',
        tags: ['Next.js', 'React', 'Tailwind CSS', 'SWR', 'Heroicons', 'TypeScript', 'OpenFoodFacts API'],
        code: 'https://github.com/Satheeshraj05/Food-Product-Explorer',
        demo: 'https://food-product-explorer-self.vercel.app/',
        image: four
    },
    {
        id: 5,
        projectName: 'Design Cartel',
        projectDesc: 'This project is a portfolio for the company to display the company products and designs',
        tags: ['Javascript', 'HTML', 'CSS', 'PHP'],
        code: 'https://github.com/Satheeshraj05/designcartel',
        demo: 'https://satheeshraj05.github.io/designcartel/',
        image: four
    },
    {
        id: 3,
        projectName: 'Secure-File-Sharing-App',
        projectDesc: 'This project is a Secure File Sharing application built with React.js for the frontend and Django REST Framework for the backend. It allows users to upload, download, and share files securely.',
        tags: ['React', 'Javascript', 'NodeJs', 'Django', 'API Endpoints', 'Branch framework',],
        code: 'https://github.com/Satheeshraj05/Secure-File-Sharing-App',
        demo: 'https://github.com/Satheeshraj05/Secure-File-Sharing-App',
        image: five
    },
    {
        id: 3,
        projectName: 'Code-Editor',
        projectDesc: 'This codebase provides a platform for creating, editing, and deleting codebases (or codebase files).',
        tags: ['React', 'Javascript', 'TypeScript', 'Vite', 'API Endpoints', 'Branch framework'],
        code: 'https://github.com/Satheeshraj05/Secure-File-Sharing-App',
        demo: 'https://github.com/Satheeshraj05/Secure-File-Sharing-App',
        image: six
    },
    
    {
        id: 2,
        projectName: 'Simpson game',
        projectDesc: 'This project aims to build a Simpson game system that focuses on improving memory.',
        tags: ['Javascript', 'HTML', 'CSS',],
        code: 'https://github.com/Satheeshraj05/Simson_game',
        demo: 'https://satheeshraj05.github.io/Simson_game/',
        image: seven
    },
    {
        id: 2,
        projectName: 'Vasitum-Dashboard',
        projectDesc: 'This admin dashboard provides insights into key HR metrics, including available positions, open jobs, new hires, total employees, and talent requests, etc.,',
        tags: ['Javascript', 'HTML', 'CSS',],
        code: 'https://github.com/Satheeshraj05/Simson_game',
        demo: 'https://satheeshraj05.github.io/Simson_game/',
        image: eight
    },

    
    // {
    //     id: 4,
    //     projectName: 'Android Patient Tracker',
    //     projectDesc: 'This project involves the development of an Android application for viewing and managing patient data.',
    //     tags: ['Flutter', 'Firebase'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: four
    // },
    // {
    //     id: 5,
    //     projectName: 'E-Commerce App',
    //     projectDesc: 'A Simple E-commerce application',
    //     tags: ['React Native', 'Firebase'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: five
    // },
    // {
    //     id: 6,
    //     projectName: 'Uber Lite',
    //     projectDesc: 'Uber clone',
    //     tags: ['Flutter'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: six
    // },
    // {
    //     id: 7,
    //     projectName: 'Stock Market App',
    //     projectDesc: 'A simple stock market API app',
    //     tags: ['React', 'Redux', 'Bootstrap'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: seven
    // },
    // {
    //     id: 8,
    //     projectName: 'Car Pooling System',
    //     projectDesc: 'The carpooling system merges multiple people in a car which leads to meet new people, reduces pollution',
    //     tags: ['Flutter', 'React'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: eight
    // },
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/